// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--xG8dd"};